export function onKeyPress(key, cb) {
    const handler = (event) => {
        if (event.key === key) cb();
    };

    document.addEventListener("keydown", handler);

    return () => document.removeEventListener("keydown", handler);
}
